<ng-template #content let-modal>
  <div class="cookie-container">
  <h3 class="m-5">{{ "acceptance194R.title" | translate }}</h3>
  <p class="m-5">{{ "acceptance194R.info" | translate }}</p> <p class="m-5">{{"acceptance194R.details" | translate}}</p>
    <div class="row">
      <div class="col-md-6 right"><button class="btn btn-lg btn-dark" (click)="acceptance()">{{ "acceptance194R.continue" | translate }}</button></div>
      <div class="col-md-6 left"> <button class="btn btn-lg btn-danger" (click)="logout()">{{ "acceptance194R.nothanks" | translate }}</button></div>
    </div>
</div> 
</ng-template>